import {DcpCustomConfigModel} from '@dcp/configurator';

export const DcpCustomConfig: DcpCustomConfigModel = {
  custom: {
    endpoints: {
      paymentDetails: '/paymentdetails',
      paymentModes: '/paymentmodes',
    },
    routes: {
      checkout: '/checkout',
      reviewOrder: '/checkout/review-order',
      cart: '/cart',
      cartEntry: '/cartEntry',
    },
  },
};
